import { axios } from '../../../axios';

const getRecentViewed = () => {
  return axios.get('/properties/recentView')
}

export { getRecentViewed }